import { render } from "./X282.vue?vue&type=template&id=37b20c8c"
import script from "./X282.vue?vue&type=script&lang=js"
export * from "./X282.vue?vue&type=script&lang=js"

import "./X282.vue?vue&type=style&index=0&id=37b20c8c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__